import * as React from 'react';
import {
  Backdrop,
  Box,
  Typography,
  LinearProgress,
  Button,
  Fade,
} from '@mui/material';

export default function ExportProgressOverlay({
  open,
  progress,
  processed,
  total,
  etaMs,
  onCancel,
  title = 'Exportando relatório',
  subtitle = 'Coletando registros e gerando arquivo…',
}) {
  const fmtEta = React.useMemo(() => {
    if (!etaMs || etaMs < 0 || !Number.isFinite(etaMs)) return '';
    const s = Math.ceil(etaMs / 1000);
    if (s < 60) return `${s}s restantes`;
    const m = Math.floor(s / 60);
    const rs = s % 60;
    return `${m}m ${rs}s restantes`;
  }, [etaMs]);

  const isBooting = (!total || total <= 0) && (!processed || processed <= 0);

  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: 1300,
        color: '#0F172A',
        backgroundColor: 'rgba(15,23,42,0.55)',
      }}>
      <Box
        role="dialog"
        aria-labelledby="export-title"
        aria-describedby="export-sub"
        sx={{
          width: 'min(720px, 92vw)',
          bgcolor: '#FFFFFF',
          borderRadius: 2,
          boxShadow: 8,
          p: 3,
        }}>
        <Typography
          id="export-title"
          variant="h6"
          sx={{ fontWeight: 700, mb: 0.5 }}>
          {title}
        </Typography>

        <Fade in={isBooting} unmountOnExit>
          <Box sx={{ mb: 1.5 }}>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
              Preparando… coleta dos dados
            </Typography>
            <LinearProgress variant="indeterminate" />
          </Box>
        </Fade>

        <Typography
          id="export-sub"
          variant="body2"
          sx={{ color: 'text.secondary', mb: 2 }}>
          {subtitle}
        </Typography>

        <Fade in={!isBooting} unmountOnExit>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ flex: 1 }}>
                <LinearProgress
                  variant="determinate"
                  value={Math.max(0, Math.min(100, progress || 0))}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-valuenow={Math.round(progress || 0)}
                />
              </Box>
              <Typography
                variant="body2"
                sx={{ minWidth: 40, textAlign: 'right' }}>
                {Math.round(progress || 0)}%
              </Typography>
            </Box>

            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {total != null
                  ? `Itens: ${processed}/${total}`
                  : `Itens: ${processed}`}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {fmtEta || '…'}
              </Typography>
            </Box>
          </Box>
        </Fade>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button
            onClick={onCancel}
            variant="outlined"
            size="small"
            color="inherit">
            Cancelar
          </Button>
        </Box>
      </Box>
    </Backdrop>
  );
}
